module.exports = __webpack_public_path__ + "img/1200px-Nomura_logo.svg.12fda742.png";